import React, { useState } from 'react';
import { Shield, Lock, Key, Clock, Save, CheckCircle, AlertCircle } from 'lucide-react';

const SecuritySettings = () => {
  const [saved, setSaved] = useState(false);
  const [settings, setSettings] = useState({
    session_timeout: 30,
    max_login_attempts: 5,
    require_2fa: false,
    password_expiry_days: 90,
    audit_log_retention: 180
  });

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-white">Security Settings</h3>
          <p className="text-gray-400 text-sm">Configure system security and authentication policies</p>
        </div>
        <button
          onClick={handleSave}
          className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg text-white"
        >
          <Save className="w-4 h-4" />
          Save Settings
        </button>
      </div>

      {saved && (
        <div className="mb-4 p-3 rounded-lg bg-green-500/20 text-green-400 border border-green-500/30">
          <CheckCircle className="w-4 h-4 inline mr-2" />
          Security settings saved successfully!
        </div>
      )}

      <div className="space-y-6 max-w-md">
        <div>
          <label className="block text-sm text-gray-400 mb-1 flex items-center gap-2">
            <Clock className="w-4 h-4" /> Session Timeout (minutes)
          </label>
          <input
            type="number"
            value={settings.session_timeout}
            onChange={(e) => setSettings({ ...settings, session_timeout: parseInt(e.target.value) })}
            className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
          <p className="text-xs text-gray-500 mt-1">Auto logout after inactivity</p>
        </div>

        <div>
          <label className="block text-sm text-gray-400 mb-1 flex items-center gap-2">
            <Lock className="w-4 h-4" /> Max Login Attempts
          </label>
          <input
            type="number"
            value={settings.max_login_attempts}
            onChange={(e) => setSettings({ ...settings, max_login_attempts: parseInt(e.target.value) })}
            className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
          <p className="text-xs text-gray-500 mt-1">Failed attempts before temporary lockout</p>
        </div>

        <div>
          <label className="block text-sm text-gray-400 mb-1 flex items-center gap-2">
            <Key className="w-4 h-4" /> Password Expiry (days)
          </label>
          <input
            type="number"
            value={settings.password_expiry_days}
            onChange={(e) => setSettings({ ...settings, password_expiry_days: parseInt(e.target.value) })}
            className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
          <p className="text-xs text-gray-500 mt-1">Users must change password after this period (0 = never)</p>
        </div>

        <div>
          <label className="block text-sm text-gray-400 mb-1 flex items-center gap-2">
            <Shield className="w-4 h-4" /> Audit Log Retention (days)
          </label>
          <input
            type="number"
            value={settings.audit_log_retention}
            onChange={(e) => setSettings({ ...settings, audit_log_retention: parseInt(e.target.value) })}
            className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
          <p className="text-xs text-gray-500 mt-1">How long to keep security logs</p>
        </div>

        <label className="flex items-center justify-between p-3 bg-gray-900/50 rounded-lg cursor-pointer">
          <div>
            <span className="text-white">Require Two-Factor Authentication (2FA)</span>
            <p className="text-xs text-gray-500">Enhanced security for all users</p>
          </div>
          <input
            type="checkbox"
            checked={settings.require_2fa}
            onChange={(e) => setSettings({ ...settings, require_2fa: e.target.checked })}
            className="w-5 h-5 rounded border-gray-600 text-blue-500 focus:ring-blue-500"
          />
        </label>
      </div>
    </div>
  );
};

export default SecuritySettings;